<div class="app-template-create content">
    <header class="sticky-header">
        <div class="left-column">
            <div class="icon-header">
                <div class="icon-container">
                    <mat-icon>library_add</mat-icon>
                </div>
                <h1 id="create-title" data-automation="pageTitle">{{ 'template.create.page_title' | translate }}</h1>
                <p class="subtitle ellipsis" data-automation="pageSubtitle">
                    {{ 'template.create.subtitle' | translate }}
                </p>
            </div>
        </div>

        <div class="right-column">
            <button
                class="icon-btn x-btn-secondary"
                aria-label="Cancel"
                (click)="handleCancel()"
                data-automation="templateCancel"
            >
                <mat-icon>clear</mat-icon>
                <span class="btn-text"> {{ 'template.button.cancel' | translate }}</span>
            </button>

            <button
                class="icon-btn x-btn-primary"
                aria-label="Submit"
                (click)="handleSubmit()"
                [disabled]="!templateForm.valid"
                type="submit"
                data-automation="templateSubmit"
            >
                <mat-icon *ngIf="!isSubmitting">done</mat-icon>
                <div *ngIf="isSubmitting" class="btn-spinner">
                    <mat-spinner diameter="15"></mat-spinner>
                </div>
                <span class="btn-text"> {{ 'template.button.submit' | translate }}</span>
            </button>
        </div>
    </header>

    <form #createForm="ngForm" data-app-prefix="prt" class="template-form">
        <app-template-form [mode]="mode" [templateForm]="templateForm"></app-template-form>
    </form>
</div>
